import React from "react"
import BackArrow from "./back-arrow"

class CashAmount extends React.Component {

  render() {
    return (
      <div className="clock-in-panel__info-window cash-amount" style={this.props.cashAmountStyle}>
        <BackArrow {...this.props}/>
        <div className="clock-in-window">
          <h1>{this.props.context == "starting_cash" ? "Starting" : "Ending"} Cash Amount</h1>
          <div className="dollar-field">
            <input placeholder="0" defaultValue="" min="0" step="0.01" type="number" ref={(e) => this.input = e}/>
          </div>
          <button onClick={() => this.props.onCashAmountDone(this.input.value, this.props.context)}>Done</button>
        </div>
      </div>
    )
  }
}

export default CashAmount
